import NavigationBar from "../navigation/nav-bar/navigationBar";
import StudentLifeRoleBody from "./studentLifeRoleBody";
import FooterComponent from "../navigation/footer/footerComponent";


export default function MainStudentLifeRoleComponent() {
    return (
        <div>
            <NavigationBar />
            <StudentLifeRoleBody />
            <FooterComponent />
        </div>
    );
}
